module.exports = __webpack_public_path__ + "assets/img/aiwriter-func2.00fcb0f9.png";